import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoginComponent} from './components/login/login.component';
import {FilesComponent} from './components/files/dialog/dialog.component';
import {PageerrorComponent} from './components/pageerror/pageerror.component';
import {TabsComponent} from './components/tabs/tabs.component';
import {MenuComponent} from './components/tabs/menu/menu.component';
import {InvestigadoresService} from './services/investigadores.service';
import {FilesService} from './services/files.service';
import {ApiService} from './services/api.service';
import {MaterialModule} from './modules/material/material.module';
import {MDBBootstrapModule} from 'angular-bootstrap-md/index';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LenguajeComponent} from './components/form/lenguaje/lenguaje.component';
import {CKEditorModule} from 'ng2-ckeditor';
import {ButtonsLenguageComponent} from './components/buttons-lenguage/buttons-lenguage.component';
import {FileComponent} from "./components/file/file.component";
import {NgProgressModule} from "ngx-progressbar";

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MDBBootstrapModule.forRoot(),
      MaterialModule,
      NgProgressModule,
      CKEditorModule
  ],
  declarations: [LoginComponent, FileComponent, FilesComponent, PageerrorComponent, TabsComponent, MenuComponent, LenguajeComponent, ButtonsLenguageComponent ],
  exports: [LoginComponent, FilesComponent, FileComponent, PageerrorComponent, TabsComponent, MenuComponent, LenguajeComponent, ButtonsLenguageComponent ],
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts